import request from '@/utils/request'

export default {
  getClassList(page, size, keyword) {
    return request.get('/class/list', {
      params: { page, size, keyword }
    })
  },

  getClassById(id) {
    return request.get(`/class/${id}`)
  },

  addClass(classData) {
    return request.post('/class/add', classData)
  },

  updateClass(classData) {
    return request.put('/class/update', classData)
  },

  deleteClass(id) {
    return request.delete(`/class/${id}`)
  }
}
